import { Routes, Route, Navigate } from 'react-router-dom'
import { AppLayout } from './components/layout/AppLayout'
import { DashboardPage } from './pages/Dashboard'
import { SettingsPage } from './pages/Settings'
import { ControlledSubstancesLogPage } from './pages/ControlledSubstancesLog'
import { LabOrderDetailPage } from './pages/LabOrderDetail'
import { LabWorkPage } from './pages/LabWork'
import { MedicationDetailPage } from './pages/MedicationDetail'
import { MedicationsPage } from './pages/Medications'
import { PrescriptionDetailPage } from './pages/PrescriptionDetail'
import { PrescriptionsPage } from './pages/Prescriptions'
import { TreatmentDetailPage } from './pages/TreatmentDetail'
import { PatientDetailPage } from './pages/PatientDetail'
import { PatientsPage } from './pages/Patients'
import { TreatmentsPage } from './pages/Treatments'

function PlaceholderPage({ name }: { name: string }) {
  return <div className="p-6 max-sm:p-3">{name}</div>
}

export default function App() {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/patients" element={<PatientsPage />} />
        <Route path="/patients/:patientId" element={<PatientDetailPage />} />
        <Route path="/treatments" element={<TreatmentsPage />} />
        <Route path="/treatments/:treatmentId" element={<TreatmentDetailPage />} />
        <Route path="/prescriptions" element={<PrescriptionsPage />} />
        <Route path="/prescriptions/:prescriptionId" element={<PrescriptionDetailPage />} />
        <Route path="/medications" element={<MedicationsPage />} />
        <Route path="/medications/:medicationId" element={<MedicationDetailPage />} />
        <Route path="/lab-work" element={<LabWorkPage />} />
        <Route path="/lab-work/:labOrderId" element={<LabOrderDetailPage />} />
        <Route path="/controlled-substances" element={<ControlledSubstancesLogPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<PlaceholderPage name="Page Not Found" />} />
      </Route>
    </Routes>
  )
}
